import { storeToRefs } from 'pinia';
import { useMainStore } from '@/store';

import { can } from '.';
import { Comment } from '@/models';

export function usePermissions() {
  const mainStore = useMainStore();
  const { user: currentUser } = storeToRefs(mainStore);

  const canEditComment = (comment: Comment): boolean => {
    if (!currentUser.value) return false;
    return comment.user?.id === currentUser.value.id;
  };

  const canDeleteComment = (comment: Comment): boolean => {
    if (!currentUser.value) return false;
    return comment.user?.id === currentUser.value.id;
  };

  const canResolveComment = (comment: Comment): boolean => {
    if (!currentUser.value || !can('can-resolve-comment')) return false;

    if (comment.user?.userroles?.length) {
      const commentUserRole = comment.user.userroles[0].name;
      if (['SuperAdmin', 'OrderAdministrator'].includes(commentUserRole)) {
        return false;
      }
    }
    return true;
  };

  return {
    canEditComment,
    canDeleteComment,
    canResolveComment,
  };
}
